// extracted by mini-css-extract-plugin
export var link = "_vs-0";